/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Delete_ConfirmInputs */

const en_cover_letters_delete_confirm = /** @type {(inputs: Cover_Letters_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this cover letter?`)
};

const de_cover_letters_delete_confirm = /** @type {(inputs: Cover_Letters_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Anschreiben löschen?`)
};

const fr_cover_letters_delete_confirm = /** @type {(inputs: Cover_Letters_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer cette lettre de motivation ?`)
};

const es_cover_letters_delete_confirm = /** @type {(inputs: Cover_Letters_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar esta carta de presentación?`)
};

const it_cover_letters_delete_confirm = /** @type {(inputs: Cover_Letters_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare questa lettera di presentazione?`)
};

const nl_cover_letters_delete_confirm = /** @type {(inputs: Cover_Letters_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze motivatiebrief verwijderen?`)
};

const pl_cover_letters_delete_confirm = /** @type {(inputs: Cover_Letters_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usunąć ten list motywacyjny?`)
};

const fi_cover_letters_delete_confirm = /** @type {(inputs: Cover_Letters_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poistetaanko tämä saatekirje?`)
};

const da_cover_letters_delete_confirm = /** @type {(inputs: Cover_Letters_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet dette ansøgningsbrev?`)
};

const sv_cover_letters_delete_confirm = /** @type {(inputs: Cover_Letters_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radera detta personliga brev?`)
};

/**
* | output |
* | --- |
* | "Delete this cover letter?" |
*
* @param {Cover_Letters_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_delete_confirm = /** @type {((inputs?: Cover_Letters_Delete_ConfirmInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Delete_ConfirmInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_delete_confirm(inputs)
	if (locale === "fr") return fr_cover_letters_delete_confirm(inputs)
	if (locale === "es") return es_cover_letters_delete_confirm(inputs)
	if (locale === "it") return it_cover_letters_delete_confirm(inputs)
	if (locale === "nl") return nl_cover_letters_delete_confirm(inputs)
	if (locale === "pl") return pl_cover_letters_delete_confirm(inputs)
	if (locale === "fi") return fi_cover_letters_delete_confirm(inputs)
	if (locale === "da") return da_cover_letters_delete_confirm(inputs)
	if (locale === "sv") return sv_cover_letters_delete_confirm(inputs)
	return en_cover_letters_delete_confirm(inputs)
});